/* ============================================================
   L'Ovetto — Configuratore a caroselli orbitali
   Anteprima a livelli: immagine base + immagine cabochon
   sovrapposte sullo stesso canvas (stesse proporzioni).
   Se un'immagine manca, si ricade sul segnaposto colorato.
   ============================================================ */
(function () {
  'use strict';

  var BASE_COLORS = {
    'bianco': '#d8d5cd',
    'rosa polvere': '#e3bfc0',
    'cipria': '#8d7d73',
    'cappuccino marrone': '#6f6144',
    'marron glace': '#4a3526',
    'nero': '#141414',
    'verde foresta': '#14150f',
    'turchese': '#2f8fa6',
    'color melanzana': '#2b1f2b',
    'color granato': '#3d1512'
  };

  var CASTONE_COLORS = {
    'madre perla bianca': '#cfcabd',
    'pietra di luna bianca': '#e6e9f0',
    'perla ametista': '#7b6ba0',
    'granato': '#7b1e2b',
    'rodolite': '#b98da0',
    'iolite': '#5b4a86',
    'ametista light': '#9c7ba8',
    'peridoto': '#8b8f4a',
    'onice': '#101010',
    'corniola': '#c1440e',
    'lapis': '#1f3f9c',
    'agata verde': '#4f7942',
    'agata blu': '#5b8fa8',
    'tormalina rosa': '#a9607c',
    'topazio giallo': '#b98330',
    'topazio sky': '#7ec8e3',
    'topazio bianco': '#f0eee9',
    'corallo rosso': '#c13b3b',
    'corallo bianco': '#f3e4de',
    'turchese stabilizzato': '#2fa6a6',
    'malachite': '#1b7a57',
    'quarzo fume': '#6b5b4d'
  };

  /* Quanto "corre" il carosello rispetto al dito: sotto 1 sembra incollato. */
  var DRAG_GAIN = 1.25;

  var DOT_POSITIONS = [
    { x: 50, y: 22 }, { x: 67, y: 30.8 }, { x: 74, y: 52 }, { x: 67, y: 73.2 },
    { x: 50, y: 82 }, { x: 33, y: 73.2 }, { x: 26, y: 52 }, { x: 33, y: 30.8 }
  ];

  function normalize(str) {
    return (str || '').toString().trim().toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function colorFor(map, name) {
    return map[normalize(name)] || '#b9b2a6';
  }

  /* Equivalente del filtro Liquid "handleize": serve a ricostruire il nome
     del file immagine lato carrello partendo dal nome della scelta. */
  function slugify(str) {
    return normalize(str).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function money(amount, currency) {
    try {
      return new Intl.NumberFormat('it-IT', { style: 'currency', currency: currency || 'EUR' }).format(amount);
    } catch (e) {
      return amount + ' €';
    }
  }

  function clampMod(n, m) { return ((n % m) + m) % m; }

  function circularDelta(index, active, length) {
    var raw = index - active;
    raw = raw - Math.round(raw / length) * length;
    return raw;
  }

  /* Verifica se un'immagine esiste davvero (i file mancanti tornano 404). */
  function probeImage(url, ok, fail) {
    if (!url) { fail(); return; }
    var img = new Image();
    img.onload = function () { ok(url); };
    img.onerror = function () { fail(); };
    img.src = url;
  }

  /* ---------------------------------------------------------
     Carosello orbitale infinito
  --------------------------------------------------------- */
  function OrbitCarousel(root, items, opts) {
    this.root = root;
    this.items = items;
    this.opts = opts || {};
    this.active = 0;
    this.dragging = false;
    this.startX = 0;
    this.startActive = 0;
    this.spacing = root.clientWidth < 420 ? 68 : 86;
    this.wheelLock = false;
    this.rafPending = false;
    this.velocity = 0;
    this.lastX = 0;
    this.lastT = 0;
    this.momentumId = null;
    this.moved = false;

    this.track = root.querySelector('.ovc__track');
    this.nodes = [];

    this._buildNodes();
    this._bindEvents();
    this.render();
  }

  OrbitCarousel.prototype._buildNodes = function () {
    var self = this;
    this.track.innerHTML = '';
    this.items.forEach(function (item, i) {
      var el = document.createElement('div');
      el.className = 'ovc__item' + (self.opts.egg ? ' ovc__item--egg' : '');
      el.setAttribute('role', 'option');
      el.setAttribute('data-index', i);
      el.setAttribute('tabindex', '-1');
      el.setAttribute('aria-label', item.title);

      var swatch = document.createElement('div');
      swatch.className = 'ovc__item-swatch';
      swatch.style.background = item.color;

      if (item.swatch) {
        var img = document.createElement('img');
        img.alt = '';
        img.loading = i < 5 ? 'eager' : 'lazy';
        img.onload = function () {
          swatch.classList.add('has-img');
          swatch.style.background = 'transparent';
        };
        img.onerror = function () { img.remove(); };
        img.src = item.swatch;
        swatch.appendChild(img);
      }
      el.appendChild(swatch);

      var label = document.createElement('div');
      label.className = 'ovc__item-label';
      label.textContent = item.title;
      el.appendChild(label);

      el.addEventListener('click', function () {
        // Dopo un trascinamento il browser emette comunque un click:
        // ignorarlo evita che il carosello rimbalzi su un altro elemento.
        if (self.moved) return;
        self.goTo(i);
      });

      self.track.appendChild(el);
      self.nodes.push(el);
    });
  };

  OrbitCarousel.prototype._bindEvents = function () {
    var self = this;
    var root = this.root;

    root.setAttribute('tabindex', '0');
    root.setAttribute('role', 'listbox');

    function onDown(x) {
      self.stopMomentum();
      self.dragging = true;
      self.moved = false;
      self.startX = x;
      self.startActive = self.active;
      self.lastX = x;
      self.lastT = performance.now();
      self.velocity = 0;
      root.classList.add('is-dragging');
      self.track.querySelectorAll('.ovc__item').forEach(function (n) { n.classList.add('is-dragging-scope'); });
    }

    function onMove(x) {
      if (!self.dragging) return;
      var now = performance.now();
      var dt = now - self.lastT;
      if (dt > 0) {
        // media mobile: smorza gli sbalzi del puntatore senza perdere reattività
        var v = (x - self.lastX) / dt;
        self.velocity = self.velocity * 0.7 + v * 0.3;
        self.lastX = x;
        self.lastT = now;
      }
      var dx = x - self.startX;
      if (Math.abs(dx) > 4) self.moved = true;
      self.active = self.startActive - dx * DRAG_GAIN / self.spacing;
      if (self.rafPending) return;
      self.rafPending = true;
      requestAnimationFrame(function () {
        self.rafPending = false;
        self.render();
      });
    }

    function onUp() {
      if (!self.dragging) return;
      self.dragging = false;
      root.classList.remove('is-dragging');
      self.startMomentum();
    }

    root.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      // Le frecce non devono avviare un trascinamento: catturare il puntatore
      // qui impedirebbe al loro click di arrivare a destinazione.
      if (e.target && e.target.closest && e.target.closest('.ovc__arrow')) return;
      root.setPointerCapture && root.setPointerCapture(e.pointerId);
      onDown(e.clientX);
    });
    root.addEventListener('pointermove', function (e) { onMove(e.clientX); });
    root.addEventListener('pointerup', onUp);
    root.addEventListener('pointercancel', onUp);
    // Niente handler su pointerleave: con la cattura del puntatore il gesto
    // deve continuare anche se il dito esce dall'area del carosello.

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(Math.round(self.active) + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(Math.round(self.active) - 1); }
      else if (e.key === 'Enter' && self.opts.onEnter) { e.preventDefault(); self.opts.onEnter(); }
    });

    /* Solo i gesti chiaramente ORIZZONTALI muovono il carosello: la rotellina
       verticale deve continuare a scorrere la pagina, non restare intrappolata. */
    var wheelTimer = null;
    root.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      if (Math.abs(e.deltaX) < 8) return;
      e.preventDefault();
      if (self.wheelLock) return;
      self.wheelLock = true;
      self.goTo(Math.round(self.active) + (e.deltaX > 0 ? 1 : -1));
      clearTimeout(wheelTimer);
      wheelTimer = setTimeout(function () { self.wheelLock = false; }, 180);
    }, { passive: false });

    window.addEventListener('resize', function () {
      self.spacing = root.clientWidth < 420 ? 68 : 86;
      self.render();
    });
  };

  OrbitCarousel.prototype.goTo = function (index) {
    this.stopMomentum();
    var length = this.items.length;
    var current = Math.round(this.active);
    var delta = circularDelta(clampMod(index, length), clampMod(current, length), length);
    this.active = current + delta;
    this.render();
    this._notify();
  };

  OrbitCarousel.prototype.stopMomentum = function () {
    if (this.momentumId) {
      cancelAnimationFrame(this.momentumId);
      this.momentumId = null;
    }
  };

  /* Inerzia dopo il trascinamento: il carosello prosegue e rallenta,
     poi si aggancia all'elemento più vicino. */
  OrbitCarousel.prototype.startMomentum = function () {
    var self = this;
    var v = -this.velocity * DRAG_GAIN / this.spacing * 16; // unità-per-frame
    var last = performance.now();

    if (Math.abs(v) < 0.02) { this.finishDrag(); return; }

    (function step(now) {
      var dt = Math.min((now - last) / 16, 3);
      last = now;
      self.active += v * dt;
      v *= Math.pow(0.93, dt);
      self.render();
      if (Math.abs(v) > 0.015) {
        self.momentumId = requestAnimationFrame(step);
      } else {
        self.momentumId = null;
        self.finishDrag();
      }
    })(last);
  };

  OrbitCarousel.prototype.finishDrag = function () {
    this.track.querySelectorAll('.ovc__item').forEach(function (n) { n.classList.remove('is-dragging-scope'); });
    this.snap();
  };

  OrbitCarousel.prototype.snap = function () {
    this.active = Math.round(this.active);
    this.render();
    this._notify();
  };

  OrbitCarousel.prototype._notify = function () {
    var idx = clampMod(Math.round(this.active), this.items.length);
    if (this.opts.onChange) this.opts.onChange(idx, this.items[idx]);
  };

  OrbitCarousel.prototype.currentIndex = function () {
    return clampMod(Math.round(this.active), this.items.length);
  };

  OrbitCarousel.prototype.render = function () {
    var self = this;
    var length = this.items.length;
    this.nodes.forEach(function (node, i) {
      var offset = circularDelta(i, self.active, length);
      var abs = Math.abs(offset);
      if (abs > 3.4) {
        node.style.opacity = '0';
        node.style.pointerEvents = 'none';
        return;
      }
      var scale = Math.max(0.42, 1 - abs * 0.17);
      var opacity = Math.max(0.15, 1 - abs * 0.3);
      var tx = offset * self.spacing;
      var ty = Math.min(abs * abs * 7, 50);
      var rot = offset * -3.5;
      node.style.opacity = String(opacity);
      node.style.pointerEvents = 'auto';
      node.style.zIndex = String(200 - Math.round(abs * 10));
      node.style.transform = 'translate(-50%,-50%) translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ') rotate(' + rot + 'deg)';
      node.setAttribute('aria-selected', abs < 0.001 ? 'true' : 'false');
    });
  };

  /* ---------------------------------------------------------
     App
  --------------------------------------------------------- */
  function initConfigurator(root) {
    var sectionId = root.getAttribute('data-section-id');
    var baseDataEl = document.getElementById('ovc-base-data-' + sectionId);
    var castoneDataEl = document.getElementById('ovc-castone-data-' + sectionId);
    if (!baseDataEl || !castoneDataEl) return;

    var currency = root.getAttribute('data-currency') || 'EUR';
    var productData = JSON.parse(baseDataEl.textContent || '{}');
    var rawCastoni = JSON.parse(castoneDataEl.textContent || '[]');

    var optionNames = productData.options || [];
    var variants = productData.variants || [];

    function optIndex(wanted) {
      for (var i = 0; i < optionNames.length; i++) {
        if (normalize(optionNames[i]) === wanted) return i;
      }
      return -1;
    }

    var baseIdx = optIndex('base');
    if (baseIdx < 0) baseIdx = 0;
    var chainIdx = optIndex('catena');

    var bases = (productData.bases || []).map(function (b) {
      return {
        title: b.title,
        layer: b.layer || null,
        swatch: b.swatch || b.layer || null,
        color: colorFor(BASE_COLORS, b.title)
      };
    });

    /* Valori della catena, dal più economico al più caro: il primo è il
       "senza catena" e diventa la scelta predefinita. */
    var chainValues = [];
    if (chainIdx >= 0) {
      var minPrice = {};
      variants.forEach(function (v) {
        var val = v.options[chainIdx];
        var p = parseFloat(v.price);
        if (minPrice[val] === undefined || p < minPrice[val]) minPrice[val] = p;
      });
      chainValues = Object.keys(minPrice).sort(function (a, b) { return minPrice[a] - minPrice[b]; });
    }

    function findVariant(baseTitle, chainValue) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options[baseIdx] !== baseTitle) continue;
        if (chainIdx >= 0 && chainValue !== null && v.options[chainIdx] !== chainValue) continue;
        return v;
      }
      return null;
    }

    /* Prezzo di una base con la catena attualmente scelta. */
    function priceFor(baseTitle, chainValue) {
      var v = findVariant(baseTitle, chainValue);
      return v ? parseFloat(v.price) : 0;
    }
    var castoni = rawCastoni.map(function (c) {
      return {
        title: c.name, layer: c.layer || null, swatch: c.swatch || null,
        color: colorFor(CASTONE_COLORS, c.name)
      };
    });

    if (!bases.length || !castoni.length) return;

    var state = {
      stepIndex: 0, baseIndex: 0, castoneIndex: 0, qty: 1,
      chain: chainValues.length ? chainValues[0] : null
    };

    var steps = Array.prototype.slice.call(root.querySelectorAll('.ovc__step'));
    var progressEls = Array.prototype.slice.call(root.querySelectorAll('.ovc__progress i'));

    var baseImgEl = root.querySelector('[data-layer="base"]');
    var cabImgEl = root.querySelector('[data-layer="castone"]');
    var fallbackEl = root.querySelector('.ovc__fallback');
    var fallbackEgg = root.querySelector('.ovc__egg');
    var fallbackDots = root.querySelector('.ovc__castoni');
    var previewCaption = root.querySelector('.ovc__preview-caption');

    var baseNameEl = root.querySelector('[data-role="base-name"]');
    var basePriceEl = root.querySelector('[data-role="base-price"]');
    var headPriceEl = root.querySelector('[data-role="head-price"]');
    var castoneNameEl = root.querySelector('[data-role="castone-name"]');

    var reviewBase = root.querySelector('[data-role="review-base"]');
    var reviewCastone = root.querySelector('[data-role="review-castone"]');
    var reviewTotal = root.querySelector('[data-role="review-total"]');
    var qtyValueEl = root.querySelector('[data-role="qty-value"]');
    var dynDescEl = root.querySelector('[data-role="dyn-desc"]');
    var dynDescTemplate = dynDescEl ? dynDescEl.innerHTML : null;
    var materialDefault = root.getAttribute('data-material-default') || 'bioresina';
    var materialSpecial = root.getAttribute('data-material-special') || 'pietra idrotermale';
    var specialBases = (root.getAttribute('data-special-bases') || '')
      .split(',').map(function (s) { return normalize(s); }).filter(Boolean);

    function escapeHtml(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    /* Riscrive la descrizione con il materiale della base e la pietra scelti. */
    function updateDynDesc() {
      if (!dynDescEl || dynDescTemplate === null) return;
      var base = bases[state.baseIndex];
      var castone = castoni[state.castoneIndex];
      var isSpecial = specialBases.indexOf(normalize(base.title)) !== -1;
      var material = isSpecial ? materialSpecial : materialDefault;
      dynDescEl.innerHTML = dynDescTemplate
        .replace(/\{materiale\}/g, escapeHtml(material))
        .replace(/\{pietra\}/g, escapeHtml(castone.title.toLowerCase()));
    }

    var chainWrap = root.querySelector('[data-role="chain-wrap"]');
    var chainOptionsEl = root.querySelector('[data-role="chain-options"]');
    var reviewChainRow = root.querySelector('[data-role="review-chain-row"]');
    var reviewChain = root.querySelector('[data-role="review-chain"]');

    DOT_POSITIONS.forEach(function (pos) {
      var dot = document.createElement('div');
      dot.className = 'ovc__castone-dot';
      dot.style.left = pos.x + '%';
      dot.style.top = pos.y + '%';
      fallbackDots.appendChild(dot);
    });

    /* Cache degli esiti di caricamento, per non ri-testare la stessa URL. */
    var probed = {};
    function withImage(url, ok, fail) {
      if (!url) { fail(); return; }
      if (probed[url] === true) { ok(url); return; }
      if (probed[url] === false) { fail(); return; }
      probeImage(url, function () { probed[url] = true; ok(url); },
                      function () { probed[url] = false; fail(); });
    }

    function updatePreview() {
      var base = bases[state.baseIndex];
      var castone = castoni[state.castoneIndex];

      withImage(base.layer, function (url) {
        baseImgEl.src = url;
        baseImgEl.alt = base.title;
        baseImgEl.classList.add('is-on');
        fallbackEgg.style.opacity = '0';
      }, function () {
        baseImgEl.classList.remove('is-on');
        baseImgEl.removeAttribute('src');
        fallbackEgg.style.opacity = '1';
        fallbackEgg.style.background = base.color;
      });

      withImage(castone.layer, function (url) {
        cabImgEl.src = url;
        cabImgEl.alt = castone.title;
        cabImgEl.classList.add('is-on');
        fallbackDots.style.opacity = '0';
      }, function () {
        cabImgEl.classList.remove('is-on');
        cabImgEl.removeAttribute('src');
        fallbackDots.style.opacity = '1';
        fallbackDots.querySelectorAll('.ovc__castone-dot').forEach(function (dot) {
          dot.style.background = castone.color;
          dot.classList.add('is-visible');
        });
      });

      previewCaption.textContent = base.title + ' · ' + castone.title;
    }

    function showStep(index, moveFocus) {
      state.stepIndex = index;
      steps.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      progressEls.forEach(function (el, i) {
        el.classList.toggle('is-done', i < index);
        el.classList.toggle('is-active', i === index);
      });
      // Il focus va spostato solo quando è l'utente a cambiare passaggio:
      // farlo al caricamento disegnerebbe un contorno sul carosello.
      if (!moveFocus) return;
      var active = steps[index];
      if (active) {
        var carouselEl = active.querySelector('.ovc__carousel');
        if (carouselEl) carouselEl.focus({ preventScroll: true });
      }
    }

    /* Le due scelte della catena, con il sovrapprezzo calcolato sulla base attiva. */
    function renderChainOptions() {
      if (!chainOptionsEl || chainValues.length < 2) return;
      var base = bases[state.baseIndex];
      var basePrice = priceFor(base.title, chainValues[0]);
      chainOptionsEl.innerHTML = '';

      chainValues.forEach(function (val) {
        var price = priceFor(base.title, val);
        var delta = price - basePrice;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ovc__addon-btn' + (val === state.chain ? ' is-selected' : '');
        btn.setAttribute('aria-pressed', val === state.chain ? 'true' : 'false');

        var label = document.createElement('span');
        label.className = 'ovc__addon-label';
        label.textContent = val;
        btn.appendChild(label);

        var extra = document.createElement('span');
        extra.className = 'ovc__addon-extra';
        extra.textContent = delta > 0 ? '+ ' + money(delta, currency) : 'Incluso';
        btn.appendChild(extra);

        btn.addEventListener('click', function () {
          state.chain = val;
          renderChainOptions();
          updateReview();
          syncHeadPrice();
        });

        chainOptionsEl.appendChild(btn);
      });

      if (chainWrap) chainWrap.hidden = false;
    }

    function currentPrice() {
      var base = bases[state.baseIndex];
      return priceFor(base.title, state.chain);
    }

    function syncHeadPrice() {
      var p = currentPrice();
      if (headPriceEl) headPriceEl.textContent = money(p, currency);
      if (basePriceEl) basePriceEl.textContent = money(p, currency);
    }

    function updateReview() {
      var base = bases[state.baseIndex];
      var castone = castoni[state.castoneIndex];
      if (reviewBase) reviewBase.textContent = base.title;
      if (reviewCastone) reviewCastone.textContent = castone.title;
      if (reviewChainRow && state.chain !== null) {
        reviewChainRow.hidden = false;
        if (reviewChain) reviewChain.textContent = state.chain;
      }
      if (reviewTotal) reviewTotal.textContent = money(currentPrice() * state.qty, currency);
      if (qtyValueEl) qtyValueEl.textContent = state.qty;
    }

    var baseCarousel = new OrbitCarousel(root.querySelector('[data-carousel="base"]'), bases, {
      egg: true,
      onChange: function (idx, item) {
        state.baseIndex = idx;
        if (baseNameEl) baseNameEl.textContent = item.title;
        syncHeadPrice();
        renderChainOptions();
        updatePreview();
        updateReview();
        updateDynDesc();
      },
      onEnter: function () { goNext(); }
    });

    var castoneCarousel = new OrbitCarousel(root.querySelector('[data-carousel="castone"]'), castoni, {
      onChange: function (idx, item) {
        state.castoneIndex = idx;
        if (castoneNameEl) castoneNameEl.textContent = item.title;
        updatePreview();
        updateReview();
        updateDynDesc();
      },
      onEnter: function () { goNext(); }
    });

    function wireArrows(name, carousel) {
      var prevBtn = root.querySelector('[data-carousel-prev="' + name + '"]');
      var nextBtn = root.querySelector('[data-carousel-next="' + name + '"]');
      if (prevBtn) prevBtn.addEventListener('click', function () { carousel.goTo(Math.round(carousel.active) - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { carousel.goTo(Math.round(carousel.active) + 1); });
    }
    wireArrows('base', baseCarousel);
    wireArrows('castone', castoneCarousel);

    if (baseNameEl) baseNameEl.textContent = bases[0].title;
    if (castoneNameEl) castoneNameEl.textContent = castoni[0].title;
    syncHeadPrice();
    renderChainOptions();
    updatePreview();
    updateReview();
    updateDynDesc();

    /* Precarica i livelli in sottofondo: il cambio in anteprima non lampeggia. */
    window.addEventListener('load', function () {
      baseCarousel.spacing = baseCarousel.root.clientWidth < 420 ? 68 : 86;
      castoneCarousel.spacing = castoneCarousel.root.clientWidth < 420 ? 68 : 86;
      baseCarousel.render();
      castoneCarousel.render();

      var queue = [];
      bases.forEach(function (b) { if (b.layer) queue.push(b.layer); });
      castoni.forEach(function (c) { if (c.layer) queue.push(c.layer); });
      var i = 0;
      (function next() {
        if (i >= queue.length) return;
        var url = queue[i++];
        withImage(url, next, next);
      })();
    });

    function goNext() { if (state.stepIndex < steps.length - 1) showStep(state.stepIndex + 1, true); }
    function goPrev() { if (state.stepIndex > 0) showStep(state.stepIndex - 1, true); }

    Array.prototype.forEach.call(root.querySelectorAll('[data-action="next"]'), function (btn) {
      btn.addEventListener('click', goNext);
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-action="prev"]'), function (btn) {
      btn.addEventListener('click', goPrev);
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-qty]'), function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-qty'), 10);
        state.qty = Math.max(1, state.qty + delta);
        updateReview();
      });
    });

    /* Trasferisce la configurazione nel form Shopify appena prima dell'invio. */
    function fillForm(form) {
      var base = bases[state.baseIndex];
      var castone = castoni[state.castoneIndex];
      var variant = findVariant(base.title, state.chain);
      if (!variant) return false;

      var select = form.querySelector('#variantSelect');
      if (select) {
        select.value = variant.id;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        var hiddenId = form.querySelector('input[name="id"]');
        if (hiddenId) hiddenId.value = variant.id;
      }

      var qtyInput = form.querySelector('#qtyInput');
      if (qtyInput) qtyInput.value = state.qty;
      var qtySpan = form.querySelector('#qty');
      if (qtySpan) qtySpan.textContent = state.qty;

      /* Proprietà della riga d'ordine. Quelle con l'underscore sono nascoste
         al cliente e servono al carrello per ricomporre l'anteprima. */
      function setProp(name, value) {
        var input = form.querySelector('input[name="properties[' + name + ']"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[' + name + ']';
          form.appendChild(input);
        }
        input.value = value;
      }

      setProp('Castone', castone.title);
      setProp('_b', slugify(base.title));
      setProp('_c', slugify(castone.title));
      return true;
    }

    var addBtn = root.querySelector('[data-action="add-to-cart"]');
    var ownForm = root.querySelector('form[action*="/cart/add"]');

    if (ownForm) {
      // Il pulsante è un submit dentro al form: basta popolare i campi prima dell'invio.
      ownForm.addEventListener('submit', function (e) {
        if (!fillForm(ownForm)) {
          e.preventDefault();
          return;
        }
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Aggiunta in corso…';
        }
      });
    } else if (addBtn) {
      // Fallback: configuratore affiancato alla buy box nativa del tema.
      addBtn.addEventListener('click', function () {
        var form = document.querySelector('.shopify-product-form');
        if (!form) return;
        if (!fillForm(form)) return;
        addBtn.disabled = true;
        addBtn.textContent = 'Aggiunta in corso…';
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }

    showStep(0);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.ovc'), initConfigurator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
